import { render, staticRenderFns } from "./AuthTicker.vue?vue&type=template&id=1c5c3754&scoped=true"
import script from "./AuthTicker.vue?vue&type=script&lang=js"
export * from "./AuthTicker.vue?vue&type=script&lang=js"
import style0 from "./AuthTicker.vue?vue&type=style&index=0&id=1c5c3754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c3754",
  null
  
)

export default component.exports